import '../css/home.scss';
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { initializeHeader } from '../pages/header';
import { fetchPagePermissions } from "../apis/graphqlClient";
import { setPermissions, hasPermission, isPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
import { getUserInformationCached } from '../modules/userManager/UserManager';
import { showPopupAlert } from '../modules/uiManager/UiPopup';
/**
 * ホーム画面を初期化する
 */
export const initializeHome = async () => {
    console.log('=== initializeHome 開始 ===');
    try {
        // ユーザー情報と権限情報を並列取得してメモリに保存
        const promises = [];
        // ユーザー情報を取得してメモリに保存
        console.log('ユーザー情報を取得中...');
        promises.push(getUserInformationCached()
            .then(userInfo => {
            console.log('ユーザー情報取得完了:', userInfo);
        })
            .catch(error => {
            console.error('ユーザー情報の取得に失敗:', error);
            showPopupAlert({
                text: 'ユーザー情報の取得に失敗しました。',
                showBackdrop: true
            });
        }));
        // 権限情報がまだ取得されていない場合は取得
        if (!isPermissionsLoaded()) {
            console.log('ページ権限情報を取得中...');
            promises.push(fetchPagePermissions()
                .then(permissions => setPermissions(permissions))
                .catch(error => {
                console.error('権限情報の取得に失敗:', error);
                if (error instanceof Error) {
                    console.error('エラーメッセージ:', error.message);
                }
                showPopupAlert({
                    text: 'ページ権限情報の取得に失敗しました。\n\n一部の機能が利用できない可能性があります。',
                    showBackdrop: true
                });
            }));
        }
        // 並列処理の完了を待機
        await Promise.all(promises);
        // ホーム画面のHTMLを取得
        const homeContent = await getHtml("/home.html");
        const subContents = document.getElementById('subContents');
        if (homeContent && subContents) {
            subContents.innerHTML = homeContent;
            // ヘッダーを初期化
            initializeHeader("建築設備ツール");
            // ボタンのイベントリスナーを設定
            setupHomeButtons();
        }
        console.log('=== initializeHome 完了 ===');
    }
    catch (error) {
        console.error('ホーム画面の初期化でエラーが発生しました:', error);
    }
};
/**
 * 権限に基づいてボタンの表示/非表示を制御
 */
function applyButtonPermissions() {
    // 各ボタンのpageIdマッピング
    const buttonPermissions = [
        { id: 'siteSurvey', pageId: 'SITE_SURVEY' },
        { id: 'restoration', pageId: 'RESTORATION' },
        { id: 'layoutBulk', pageId: 'LAYOUT_BULK' },
        { id: 'layoutView', pageId: 'LAYOUT_VIEW' },
        { id: 'storeNumBatch', pageId: 'STORE_NUM_BATCH' },
    ];
    buttonPermissions.forEach(({ id, pageId }) => {
        const button = document.getElementById(id);
        if (button) {
            // idと一致するpageIdが取得されていればボタンを表示
            if (hasPermission(pageId)) {
                button.classList.remove('hidden');
            }
            else {
                button.classList.add('hidden');
            }
        }
    });
}
/**
 * ホーム画面のボタンにイベントリスナーを設定
 */
function setupHomeButtons() {
    // 建築設備進捗確認ボタン
    const progressButton = document.getElementById('progressCheck');
    if (progressButton) {
        progressButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/store-list');
        });
    }
    // 現地調査依頼ボタン
    const siteSurveyButton = document.getElementById('siteSurvey');
    if (siteSurveyButton) {
        siteSurveyButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/field-survey-request-list');
        });
    }
    // 現状回復打合せ依頼ボタン
    const restorationButton = document.getElementById('restoration');
    if (restorationButton) {
        restorationButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('');
        });
    }
    // レイアウト一括取得ボタン
    const layoutBulkButton = document.getElementById('layoutBulk');
    if (layoutBulkButton) {
        layoutBulkButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/layout-bulk-download');
        });
    }
    // レイアウト閲覧ボタン
    const layoutViewButton = document.getElementById('layoutView');
    if (layoutViewButton) {
        layoutViewButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/layout-view');
        });
    }
    // 店番変更ボタン
    const storeNumBatchButton = document.getElementById('storeNumBatch');
    if (storeNumBatchButton) {
        storeNumBatchButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/store-change-batch');
        });
    }
}
